import styled from 'styled-components';
import "../../styles/abstract/variables";
import { colorBlack, colorGrayText, colorPrimaryDark2Hex, colorPrimaryText, colorWhite2 } from '../../styles/abstract/variables';

export const EventCardStyled = styled.div.attrs(({ detailed, ...rest}) => ({
    ...rest
}))`
    width: 100%;
    background-color:${colorWhite2};
    color: ${colorBlack};
    border-radius: 1rem;
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, .1);
    
    .event-card__image {
        width: 100%;
        height: 25rem;
        overflow: hidden;

        & img {
            width: 100%;
            height: 100%;
            border-top-left-radius: ${props => props.detailed ? '.5rem' : '1rem'};
            border-top-right-radius: ${props => props.detailed ? '.5rem' : '1rem'};;
            object-fit: fill;
            object-position: bottom;
            cursor: pointer;
            transition: all 1s;
        }
        
        &:hover img{
            transform: scale(1.1);
        }
    }

    .event-card__description {
        padding: 1rem 3rem;
    }

    .event-card__location {
        display: inline-block;
        color: ${colorGrayText}; 
    }

    .event-card__name {
        color: ${colorPrimaryDark2Hex};
        font-size: 2rem;
        font-weight: 600;
        display: inline-block;
        text-overflow: ellipsis;
        height: 3rem;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
    }

    .event-card__date {
        color: ${colorGrayText}; 
        font-size: 1.5rem;
        font-weight: 400;
    }

    .event-card__tags {
        display: ${props => props.detailed ? 'block' : 'none'};
    }

    .event-card__price {
        display: ${props => props.detailed ? 'block' : 'none'};
        color: ${colorPrimaryText};
        font-weight: 700;
        font-size: 1.5rem;
    }

    .event-card__button {
        display: ${props => props.detailed ? 'block' : 'none'};
    }
`